module.exports = __webpack_public_path__ + "assets/img/5_1175.4fed2242.jpg";